import { API } from "aws-amplify";

const index = async (params) => {
    let myInit = { // OPTIONAL
        response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
        queryStringParameters: params,
        headers: {} // OPTIONAL
    };
    let items = await API.get("InasakuAPI", "/inasaku/watergate", myInit);

    return items;
};
const indexLogs = async (params) => {
    let myInit = { // OPTIONAL
        response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
        queryStringParameters: params,
        headers: {} // OPTIONAL
    };
    let items = await API.get("InasakuAPI", "/inasaku/watergate/logs", myInit);

    return items;
};
const insertWaterSupply = async (params) => {
    let myInit = {
        response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
        body: {
            data: params
        },
        headers: {} // OPTIONAL
    };
    let res = await API.post("InasakuAPI", "/inasaku/watergate/supply", myInit);

    return res;
};
const insertWaterOut = async (params) => {
    let myInit = {
        response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
        body: {
            data: params
        },
        headers: {} // OPTIONAL
    };
    let res = await API.post("InasakuAPI", "/inasaku/watergate/out", myInit);

    return res;
};
const insertWaterSupplyGates = async (params) => {
    let myInit = {
        response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
        body: {
            data: params
        },
        headers: {} // OPTIONAL
    };
    let res = await API.post("InasakuAPI", "/inasaku/watergates/supply", myInit);

    return res;
};
const insertWaterOutGates = async (params) => {
    let myInit = {
        response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
        body: {
            data: params
        },
        headers: {} // OPTIONAL
    };
    let res = await API.post("InasakuAPI", "/inasaku/watergates/out", myInit);

    return res;
};

export default {
    index: index,
    indexLogs: indexLogs,
    insertWaterSupply: insertWaterSupply,
    insertWaterOut: insertWaterOut,
    insertWaterSupplyGates: insertWaterSupplyGates,
    insertWaterOutGates: insertWaterOutGates,
};
